import type { TermsRepositoryPort } from "../ports/terms.repository.port";

export function getCurrentTermsUseCase(repository: TermsRepositoryPort) {
  return repository.getCurrent();
}
